/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-volunteer.reducer';

export const PatientVolunteerDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientVolunteerEntity = useAppSelector(state => state.patientVolunteer.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientVolunteerDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientVolunteer.detail.title">PatientVolunteer</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientVolunteer.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientVolunteerEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientVolunteer.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientVolunteerEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientVolunteer.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientVolunteerEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientVolunteer.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientVolunteerEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientVolunteer.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientVolunteerEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientVolunteer.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientVolunteerEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientVolunteer.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{patientVolunteerEntity.glucoUser ? patientVolunteerEntity.glucoUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientVolunteer.paramedic">Paramedic</Translate>
          </dt>
          <dd>{patientVolunteerEntity.paramedic ? patientVolunteerEntity.paramedic.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-volunteer" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-volunteer/${patientVolunteerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientVolunteerDetail;
